module.exports = __webpack_public_path__ + "img/JUGAR.6e0e6c20.png";